import axios from "axios";
import { config } from "../../Constants";

export const memorialApi = {
  getSummary,
  getTopN,
  getuserComment,
  addComment,
  updateComment,
  getuserRip,
  createRip,
  getuserProfile,
};

function getSummary() {
  return instance.get("/memorial/global/summary");
}
function getTopN({ n }) {
  return instance.get("/memorial/global/top-n", {
    params: { n },
  });
}

function getuserComment(token) {
  return instance.get("/memorial/user/comment", {
    headers: { Authorization: bearerAuth(token) },
  });
}

function addComment(token, comment) {
  return instance.post(
    "/memorial/user/comment",
    { comment },
    {
      headers: { Authorization: bearerAuth(token) },
    }
  );
}

function updateComment(token, comment) {
  return instance.put("/memorial/user/comment", comment, {
    headers: { Authorization: bearerAuth(token) },
  });
}

function getuserRip() {
  return instance.get("/memorial/global/rip");
}

function createRip(rip) {
  return instance.post("/memorial/global/rip", rip);
}

function getuserProfile(token) {
  return instance.get("/memorial/user/profile", {
    headers: { Authorization: bearerAuth(token) },
  });
}
// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response.status === 404) {
      return { status: error.response.status };
    }
    return Promise.reject(error.response);
  }
);

// -- Helper functions

function bearerAuth(token) {
  return `Bearer ${token}`;
}
